'use client';
import { useChainInfo } from '@/lib/hooks/useChainInfo';
import { useTranslations } from 'next-intl';
import { AgentGrid } from './AgentGrid';
import { AgentList } from './AgentList';
import { Box, HStack, Text } from '@chakra-ui/react';
import { SOLANA_CHAIN_ID, BSC_CHAIN_ID } from '@/lib/config/chain';

export default function AgentPage() {
  const t = useTranslations('HomePage');
  const { chainId } = useChainInfo();

  return chainId === SOLANA_CHAIN_ID || chainId === BSC_CHAIN_ID ? (
    <>
      <Box flex={1} bg="bg.t1" rounded={12} pos="relative">
        <HStack h={'52px'} alignItems={'center'} pl={'16px'}>
          <Text>{t('agent.aggressive')}</Text>
        </HStack>
        <AgentList version={'2'} />
      </Box>
      <Box flex={1} bg="bg.t1" rounded={12} pos="relative">
        <HStack h={'52px'} alignItems={'center'} pl={'16px'}>
          <Text>{t('agent.conservative')}</Text>
        </HStack>
        <AgentList version={'1'} />
      </Box>
    </>
  ) : (
    <AgentGrid />
  );
}
